import { i18n } from 'src/boot/i18n';

export function getCalculatedInvoiceFields() {
  return [
    {
      field_name: 'invoice_due_date',
      field_display_label: i18n.t('invoice_due_date'),
      title: i18n.t('invoice_due_date'),
      field_type: 'DATE',
      is_readonly: true,
      calculation_formula: i18n.t('invoice_due_date_explanation'),
    },
    {
      field_name: 'discount_due_date',
      field_display_label: i18n.t('discount_due_date'),
      title: i18n.t('discount_due_date'),
      field_type: 'DATE',
      is_readonly: true,
      calculation_formula: i18n.t('discount_due_date_explanation'),
    },
    {
      field_name: 'discount_term',
      field_display_label: i18n.t('discount_term'),
      title: i18n.t('discount_term'),
      field_type: 'STRING',
      is_readonly: true,
      calculation_formula: i18n.t('discount_term_explanation'),
    },
    {
      field_name: 'payment_term_description',
      field_display_label: i18n.t('payment_term_description'),
      title: i18n.t('payment_term_description'),
      field_type: 'STRING',
      is_readonly: true,
      calculation_formula: i18n.t('payment_term_description_explanation'),
    },
    {
      field_name: 'ap_assignment_code',
      field_display_label: i18n.t('ap_assignment_code'),
      title: i18n.t('ap_assignment_code'),
      field_type: 'STRING',
      is_readonly: true,
      calculation_formula: i18n.t('ap_assignment_code_explanation'),
    },
  ];
}

// DK-10: doc types that may legitimately surface the calculated_fields group.
const CALCULATED_FIELDS_ALLOWLIST = ['INVOICE', 'SUPPLIER_INVOICE'] as const;

export function injectCalculatedFields(
  fieldSettings: any,
  docType: string | null = null,
  enabled: boolean = false,
) {
  if (!enabled) return;

  const requested = docType ? [docType] : [...CALCULATED_FIELDS_ALLOWLIST];
  const docTypes = requested.filter((dt) =>
    (CALCULATED_FIELDS_ALLOWLIST as readonly string[]).includes(dt),
  );
  if (docTypes.length === 0) return;

  const calculatedFields = getCalculatedInvoiceFields();

  docTypes.forEach((dt) => {
    const settings = Array.isArray(fieldSettings) ? fieldSettings : fieldSettings[dt];
    if (!settings) return;

    const allFields = settings.flatMap((g: any) =>
      (g.rows || []).flatMap((r: any) => r),
    );
    const missingFields = calculatedFields.filter(
      (cf) => !allFields.some((f: any) => f.field_name === cf.field_name),
    );

    if (missingFields.length === 0) return;

    settings.push({
      name: 'calculated_fields',
      title: i18n.t('calculated_fields'),
      translation_key: 'calculated_fields',
      rows: [missingFields],
    });
  });
}
